module.exports = __webpack_public_path__ + "static/media/create.9869db4f.gif";